import { Box } from '@mui/material';

interface EventBannerProps {
  image?: string;
  title?: string;
}

export function EventBanner({ image, title }: EventBannerProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        paddingTop: { xs: '56.25%', md: '40.25%' },
        borderRadius: { xs: 1, md: 2 },
        overflow: 'hidden',
        bgcolor: '#e0e0e0',
        mb: { xs: 2, md: 3 },
      }}
    >
      {image ? (
        <img
          src={image}
          alt={title || 'Imagem do evento'}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      ) : (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#e0e0e0',
            color: 'text.secondary',
          }}
        />
      )}
    </Box>
  );
}

